import React, { useState, useEffect } from "react";
import {
  TabPane,
  Card,
  Button,
  CardText,
  Row,
  Col,
  Label,
  Input,
  CardBody,
} from "reactstrap";
import "./index.css";
import ApiCaller from "../../../../api/apiCaller";
import constants from "../../../../constants";
import PhotoPlaceholder from "resources/images/photo_placeholder.jpg";
import Lightbox from "react-image-lightbox";

interface ImageTabProps {
  isView: boolean;
  storeData: any;
  setStoreData: Function;
  selectedPhotos: any;
  setSelectedPhotos: Function;
  onImageRemoved?: Function;
}

export default function ImagesTab({
  isView,
  storeData,
  setStoreData,
  selectedPhotos,
  setSelectedPhotos,
  onImageRemoved,
}: ImageTabProps) {
  const [imageBoxState, setImageBoxState] = useState({
    showLightBox: false,
    photoIndex: 0,
  });

  // const [imageData, setImageData] = useState({
  //   images: [],
  //   imageTitles: [],
  //   imageCaptions: [],
  // });

  let images: any = [];
  let imageTitles: any = [];
  let imageCaptions: any = [];
  if (storeData?.data?.photos) {
    constants.SITE_IMAGE_ATTRIBUTES.map((eachAttribute) => {
      const imageAttribute = eachAttribute.key;
      if (storeData?.data?.photos[imageAttribute]) {
        images.push(storeData?.data?.photos[imageAttribute]["url"]);
        imageTitles.push(eachAttribute.name);
        imageCaptions.push(
          storeData?.data?.photos[imageAttribute]["caption_text"]
        );
      }
    });
  }

  useEffect(() => {}, []);

  const onImageClick = (imageUrl: any, imageArray: any) => {
    imageArray.map((url: string, idx: any) => {
      if (url === imageUrl) {
        setImageBoxState({
          showLightBox: true,
          photoIndex: idx,
        });
      }
    });
  };

  const removeAttachment = async (attachmentId: any, imageAttribute: string) => {
    if (!attachmentId) alert('Lỗi: không tìm thấy attachment_id');
    const confirmationBox = window.confirm('Bạn có chắc sẽ xóa hình này?');
    if (!confirmationBox) return;
    const uri = `file_attachment/${attachmentId}/delete`;
    const res = await ApiCaller.delete(uri);
    if (res.status === 'ok') {
      if (onImageRemoved) {
        onImageRemoved(imageAttribute);
      }
    } else {
      alert(res.msg);
    }
  }

  return (
    <TabPane tabId="image_tab">
      <Row>
        {constants.STORE_IMAGE_ATTRIBUTES.map((eachAttribute) => {
          const imageAttribute = eachAttribute.key;
          const imageName = eachAttribute.name;
          return (
            <Col
              sm={{ size: 6, offset: 0 }}
              key={imageAttribute}
              style={{ marginTop: 30 }}
            >
              <Card>
                {selectedPhotos &&
                selectedPhotos[imageAttribute] &&
                selectedPhotos[imageAttribute]["url"] ? (
                  <img
                    className="store-edit-img"
                    src={URL.createObjectURL(
                      selectedPhotos[imageAttribute]["url"]
                    )}
                  />
                ) : storeData?.data?.photos &&
                  storeData?.data?.photos[imageAttribute] &&
                  storeData?.data?.photos[imageAttribute]["url"] ? (
                  <div
                    className="store-edit-img"
                    style={{
                      backgroundImage: `url(${storeData?.data?.photos[imageAttribute]["url"]})`,
                    }}
                    onClick={() =>
                      onImageClick(
                        storeData?.data?.photos[imageAttribute]["url"],
                        images
                      )
                    }
                  >
                    {!isView && storeData?.data?.photos &&
                      storeData?.data?.photos[imageAttribute] &&
                      storeData?.data?.photos[imageAttribute]["url"] && (
                        <Button
                          onClick={(e) => {
                            e.stopPropagation();
                            removeAttachment(
                              storeData?.data?.photos[imageAttribute][
                                "attachment_id"
                              ],
                              imageAttribute
                            );
                          }}
                          className="store-edit-img-delete-button"
                          color="danger"
                          size="sm"
                        >
                          Xóa
                        </Button>
                    )}
                  </div>
                ) : (
                  <div
                    className="store-edit-img"
                    style={{
                      backgroundImage: `url(${PhotoPlaceholder})`,
                    }}
                  />
                )}
                <CardBody>
                  {/* <CardTitle>{imageName}</CardTitle> */}
                  <Label>{imageName}</Label>
                </CardBody>
                {isView ? (
                  <CardBody>
                    <CardText>
                      {storeData?.data?.photos &&
                      storeData?.data?.photos[imageAttribute]
                        ? storeData?.data?.photos[imageAttribute][
                            "caption_text"
                          ]
                        : ""}
                    </CardText>
                  </CardBody>
                ) : (
                  <CardBody>
                    <Input
                      accept="image/*,video/*"
                      type="file"
                      onChange={(event: any) => {
                        setSelectedPhotos({
                          ...selectedPhotos,
                          ...{
                            [imageAttribute]: {
                              ...(selectedPhotos &&
                              selectedPhotos[imageAttribute]
                                ? selectedPhotos[imageAttribute]
                                : {}),
                              ...{ url: event?.target?.files[0] },
                            },
                          },
                        });
                      }}
                    >
                      Chọn ảnh nha
                    </Input>
                    <Input
                      type="text"
                      style={styles.imageNote}
                      placeholder="Ghi chú"
                      value={
                        selectedPhotos &&
                        selectedPhotos[imageAttribute] &&
                        (selectedPhotos[imageAttribute]["caption_text"] ||
                          selectedPhotos[imageAttribute]["caption_text"] === "")
                          ? selectedPhotos[imageAttribute]["caption_text"]
                          : storeData?.data?.photos &&
                            storeData?.data?.photos[imageAttribute] &&
                            storeData?.data?.photos[imageAttribute][
                              "caption_text"
                            ]
                          ? storeData?.data?.photos[imageAttribute][
                              "caption_text"
                            ]
                          : ""
                      }
                      onChange={(event: any) =>
                        setSelectedPhotos({
                          ...selectedPhotos,
                          ...{
                            [imageAttribute]: {
                              ...(selectedPhotos &&
                              selectedPhotos[imageAttribute]
                                ? selectedPhotos[imageAttribute]
                                : {}),
                              ...{ caption_text: event?.target?.value },
                            },
                          },
                        })
                      }
                    />
                  </CardBody>
                )}
              </Card>
            </Col>
          );
        })}
      </Row>
      {imageBoxState?.showLightBox && (
        <Lightbox
          mainSrc={images[imageBoxState?.photoIndex]}
          nextSrc={images[(imageBoxState?.photoIndex + 1) % images.length]}
          prevSrc={
            images[
              (imageBoxState?.photoIndex + images.length - 1) % images.length
            ]
          }
          onCloseRequest={() =>
            setImageBoxState({ ...imageBoxState, ...{ showLightBox: false } })
          }
          onMovePrevRequest={() =>
            setImageBoxState({
              ...imageBoxState,
              ...{
                photoIndex:
                  (imageBoxState?.photoIndex + images.length - 1) %
                  images.length,
              },
            })
          }
          onMoveNextRequest={() =>
            setImageBoxState({
              ...imageBoxState,
              ...{
                photoIndex: (imageBoxState?.photoIndex + 1) % images.length,
              },
            })
          }
          imageTitle={imageTitles[imageBoxState?.photoIndex]}
          imageCaption={imageCaptions[imageBoxState?.photoIndex]}
        />
      )}
    </TabPane>
  );
}

const styles = {
  customTextInput: {
    marginTop: 20,
  },
  imageNote: {
    marginTop: 12,
  },
};
